import React from 'react';
import { withErrorBoundary } from '@twigeducation/allsorts';
import { InlineError } from '@twigeducation/ts-fe-components';
import * as Sentry from '@sentry/react';
import ReactGA4 from 'react-ga4';
import DrawingTool from './DrawingTool';
import { withTranslation } from '../withTranslation';
import { useTranslation } from '../useTranslation';

const Fallback = () => {
    const { t } = useTranslation();
    const message = t('errors.error_rendering_page', 'An error occurred when trying to render the drawing tool');
    return (
        <>
            <InlineError title={t('errors.something_went_wrong', 'Sorry, something went wrong')} body={message} />
        </>
    );
};

export default withErrorBoundary(<Fallback />, error => {
    Sentry.withScope(scope => {
        scope.setTag('errorBoundary', 'true');
        scope.setTag('mfe', 'twig-drawing-tool');
        Sentry.captureException(error);
    });
    ReactGA4.event('Error_Exception', {
        Error_Exception_Msg: 'The drawing tool cannot be displayed',
        Error_Exception_URL: window.location.href,
    });
})(withTranslation()(DrawingTool));
